import React from 'react'
import { Link } from 'react-router-dom'
import {
  IonContent,
  IonImg,
  IonButton,
  IonIcon
} from '@ionic/react'
import {
  chevronForwardOutline,
  chevronBackOutline
} from 'ionicons/icons'
import { Advertisement } from '../../../components/common/Advertisement'
import './styles.scss'

const ResultRow = (props) => {
  const { content } = props
  return (
    <div
      className='result-row'
    >
      <figure>
        <Link
          to={`/${content.section_url === 'news' ? 'leer' : 'ver'}/${content.id}_${content.url_title}`}
        >
          <IonImg
            src={content.miniature}
            alt={content.title}
          />
        </Link>
      </figure>
      <figcaption>
        <Link
          to={`/${content.section_url === 'news' ? 'leer' : 'ver'}/${content.id}_${content.url_title}`}
        >
          <h1 className='title'>
            {content.title}
          </h1>
        </Link>
        <p className='abstract'>
          {content.intro}
        </p>
        {content.section_url === 'news' &&
          <div className='classification'>
            <Link to='/news/1'>
              {content.section}
            </Link>
            <Link to='/news/1'>
              {content.category}
            </Link>
          </div>}
        {content.section_url === 'radio' &&
          <div className='classification'>
            <Link to='/originales/explorar'>
              {content.section}
            </Link>
            <Link to={`/${content.category_url}/explorar`}>
              {content.category}
            </Link>
            <Link to={`/${content.category_url}/${content.id_product}_${content.product_url}/1`}>
              {content.category}
            </Link>
          </div>}
      </figcaption>
    </div>
  )
}

const Results = (props) => {
  const { results } = props
  return (
    <IonContent
      fullscreen
      className='results page-wrapper'
    >
      <div className='flexible-width-content'>
        <Advertisement />

        <section>
          {results?.data && results.data.map((result, index) => (
            <ResultRow
              content={result}
              key={index}
            />
          ))}
        </section>
        {results.pages > 1 &&
          <section className='pagination-container'>
            {results.currentPage > 1 &&
              <Link to={`/busqueda/${parseInt(results.currentPage) - 1}?q=${results.query}`}>
                <IonButton className='previous'>
                  <IonIcon icon={chevronBackOutline} />
                </IonButton>
              </Link>}

            {results.currentPage < results.pages &&
              <Link to={`/busqueda/${parseInt(results.currentPage) + 1}?q=${results.query}`}>
                <IonButton className='next'>
                  <IonIcon icon={chevronForwardOutline} />
                </IonButton>
              </Link>}
          </section>}
        <Advertisement />
      </div>
    </IonContent>
  )
}

export default Results
